"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var crawlers = [
    'Googlebot',
    'Bingbot',
    'DuckDuckBot',
    'Baiduspider',
    'Slurp',
    'facebot',
    'facebook',
    'oncrawl',
];
var isCrawler = function (uaString) {
    // Check that the UA string exists, prevents some malicious actors which
    // attempt to hit the site without a UA string, typically scrapers do this.
    return (lodash_1.isEmpty(uaString) ||
        crawlers.some(function (crawler) {
            var needle = (uaString || '').toLowerCase();
            return needle.includes(crawler.toLowerCase());
        }));
};
exports.default = isCrawler;
